import { useState, useEffect } from 'react';
import './Header.css';

function Header({ onNavigateToLogin }) {
  const [webComponentsLoaded, setWebComponentsLoaded] = useState(false);

  useEffect(() => {
    // Check if web components are loaded
    const checkWebComponents = () => {
      if (customElements.get('som-header')) {
        setWebComponentsLoaded(true);
      } else {
        // Try again in 100ms
        setTimeout(checkWebComponents, 100);
      }
    };

    checkWebComponents();
  }, []);

  const handleHeaderClick = (e) => {
    // If clicking on the header brand/logo area, navigate to login
    if (e.target.closest('.som-header__brand') || e.target.closest('.som-header__logo') || e.target.closest('.som-header__titles')) {
      e.preventDefault();
      if (onNavigateToLogin) {
        onNavigateToLogin();
      }
    }
  };

  // Fallback to custom header if web components aren't loaded
  if (!webComponentsLoaded) {
    return (
      <>
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <header className="som-header" role="banner" aria-label="Site header">
          <div className="som-header__container">
            <div
              className="som-header__brand"
              onClick={handleHeaderClick}
              style={{ cursor: 'pointer' }}
              role="button"
              tabIndex="0"
              aria-label="Return to login page"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleHeaderClick(e);
                }
              }}
            >
              <div className="som-header__logo">
                <span className="michigan-logo">🏛️</span>
              </div>
              <div className="som-header__titles">
                <span className="som-header__department">
                  Department of Health and Human Services
                </span>
                <span className="som-header__app">
                  JJ Bed Providers Tool
                </span>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }

  const headerHTML = `
    <som-header
      app-name="JJ Bed Providers Tool"
      department-name="Department of Health and Human Services"
      home-link="#"
      main-content-id="main-content"
      sticky="false"
      breakpoint="lg">
    </som-header>
  `;

  return (
    <div
      dangerouslySetInnerHTML={{ __html: headerHTML }}
      onClick={(e) => {
        // Handle clicks on the SOM web component header
        if (e.target.closest('som-header')) {
          e.preventDefault();
          if (onNavigateToLogin) {
            onNavigateToLogin();
          }
        }
      }}
      style={{ cursor: 'pointer' }}
    />
  );
}

export default Header;
